/**
 * Path3D parser: the Node3D transform surface plus the raw `curve` resource
 * reference. The component resolves and tessellates the Curve3D.
 */
import { parseNode3D } from '../../base/node3d/parser';
export function parsePath3D(heading, properties) {
    const base = parseNode3D(heading, properties);
    const result = { ...base };
    if (properties.curve)
        result.curve = properties.curve;
    return result;
}
//# sourceMappingURL=parser.js.map